import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationButtonsComponent } from './button.component';



@NgModule({
  declarations: [NavigationButtonsComponent],
  imports: [
    CommonModule
  ],
  exports:[NavigationButtonsComponent]
})
export class ButtonModule { }
